import {
  FETCH_DAILY_BRIEF_START,
  FETCH_DAILY_BRIEF_SUCCESS,
  FETCH_DAILY_BRIEF_ERROR,
  LOAD_MORE_DAILY_BRIEF_START,
  LOAD_MORE_DAILY_BRIEF_SUCCESS,
  LOAD_MORE_DAILY_BRIEF_ERROR,
  FETCH_SETTINGS_START,
  FETCH_SETTINGS_SUCCESS,
  FETCH_SETTINGS_ERROR,
  UPDATE_SETTINGS_START,
  UPDATE_SETTINGS_SUCCESS,
  UPDATE_SETTINGS_ERROR,
  UPDATE_SETTINGS_OPTIMISTIC,
  FETCH_FILTER_SELECTIONS_START,
  FETCH_FILTER_SELECTIONS_SUCCESS,
  FETCH_FILTER_SELECTIONS_ERROR,
  RESET_DAILY_BRIEF_DATA,
  SET_FILTER_TYPE,
  SET_FILTER_IDS,
  SET_SORT_BY,
  SET_SORT_DIRECTION,
} from './actionTypes';

const initialState = {
  data: [],
  totalCount: 0,
  page: 1,
  pageSize: 20,
  settings: {
    defaultFilterType: 1,
    defaultFilterIds: [],
    defaultSortBy: 'name',
    defaultSortOrder: 'asc',
  },
  filterSelections: [],
  isLoading: false,
  isLoadingMore: false,
  isLoadingSettings: false,
  isLoadingSelections: false,
  isUpdatingSettings: false,
  settingsLoaded: false,
  hasMoreData: true,
  hasAssignments: null,
  hasQuestionnaireAlerts: null,
  error: null,
  settingsError: null,
  selectionsError: null,
  lastFetch: null,
  cacheKey: null,
};

const dailyBriefDataReducer = (state = initialState, action) => {
  switch (action.type) {
    // Daily Brief Data
    case FETCH_DAILY_BRIEF_START:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case FETCH_DAILY_BRIEF_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        totalCount: action.payload.totalCount,
        page: action.payload.page,
        pageSize: action.payload.pageSize,
        hasMoreData: action.payload.hasMoreData,
        hasAssignments: action.payload.hasAssignments,
        hasQuestionnaireAlerts: action.payload.hasQuestionnaireAlerts,
        error: null,
        lastFetch: Date.now(),
        cacheKey: action.payload.cacheKey,
      };

    case FETCH_DAILY_BRIEF_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    // Load More Daily Brief Data
    case LOAD_MORE_DAILY_BRIEF_START:
      return {
        ...state,
        isLoadingMore: true,
        error: null,
      };

    case LOAD_MORE_DAILY_BRIEF_SUCCESS:
      return {
        ...state,
        isLoadingMore: false,
        data: [...state.data, ...action.payload.data],
        page: action.payload.page,
        hasMoreData: action.payload.hasMoreData,
        // Preserve previous value if payload doesn't include it
        hasAssignments: action.payload.hasAssignments ?? state.hasAssignments,
        hasQuestionnaireAlerts:
          action.payload.hasQuestionnaireAlerts ?? state.hasQuestionnaireAlerts,
        error: null,
        lastFetch: Date.now(),
      };

    case LOAD_MORE_DAILY_BRIEF_ERROR:
      return {
        ...state,
        isLoadingMore: false,
        error: action.payload,
      };

    case RESET_DAILY_BRIEF_DATA:
      return {
        ...state,
        data: [],
        page: 1,
        hasMoreData: true,
        hasAssignments: null,
        hasQuestionnaireAlerts: null,
        lastFetch: null,
        cacheKey: null,
        isLoading: true,
      };

    // Settings
    case FETCH_SETTINGS_START:
      return {
        ...state,
        isLoadingSettings: true,
        settingsError: null,
      };

    case FETCH_SETTINGS_SUCCESS:
      return {
        ...state,
        isLoadingSettings: false,
        settings: { ...state.settings, ...action.payload },
        settingsLoaded: true,
        settingsError: null,
      };

    case FETCH_SETTINGS_ERROR:
      return {
        ...state,
        isLoadingSettings: false,
        settingsError: action.payload,
      };

    case UPDATE_SETTINGS_OPTIMISTIC:
      return {
        ...state,
        settings: { ...state.settings, ...action.payload },
      };

    case UPDATE_SETTINGS_START:
      return {
        ...state,
        isUpdatingSettings: true,
        settingsError: null,
      };

    case UPDATE_SETTINGS_SUCCESS:
      return {
        ...state,
        isUpdatingSettings: false,
        settings: { ...state.settings, ...action.payload },
        settingsError: null,
      };

    case UPDATE_SETTINGS_ERROR:
      return {
        ...state,
        isUpdatingSettings: false,
        settingsError: action.payload,
      };

    // Filter Selections
    case FETCH_FILTER_SELECTIONS_START:
      return {
        ...state,
        isLoadingSelections: true,
        selectionsError: null,
      };

    case FETCH_FILTER_SELECTIONS_SUCCESS:
      return {
        ...state,
        isLoadingSelections: false,
        filterSelections: action.payload,
        selectionsError: null,
      };

    case FETCH_FILTER_SELECTIONS_ERROR:
      return {
        ...state,
        isLoadingSelections: false,
        selectionsError: action.payload,
      };

    case SET_FILTER_TYPE:
    case SET_FILTER_IDS:
    case SET_SORT_BY:
    case SET_SORT_DIRECTION:
      return {
        ...state,
        isLoading: true,
      };

    default:
      return state;
  }
};

export default dailyBriefDataReducer;
